import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { MultiSelector } from '../models/selector/multi-selector-model';

@Component({
  selector: 'single-selector',
  templateUrl: './single-selector.component.html',
  styleUrls: ['./single-selector.component.scss']
})

export class SingleSelectorComponent implements OnInit {

  public expandedKeys: any[] = [];
  public selectorOpened: boolean = false;
  public disableSelector: boolean = false;
  @Input() selectedName: string = "Select";
  @Input() selectedId: number = 0;
  @Input() displayName: string;
  @Input() searchKey: string;
  @Input() labelText: string;
  @Input() hoverText: string;
  @Input() isIncludeFloatLocation: boolean = true;
  @Input() enableAllNodes: boolean = false;
  @Input() selectableTypes: number[] = []; // an array of location types to be made selectable
  @Input() selectorDisabled: boolean = false;
  @Input() public dataHierarchy: MultiSelector;
  @Output() onChange: EventEmitter<Array<any>> = new EventEmitter();
  @Output() onData = new EventEmitter<any>();

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    this.onData.emit(this.dataHierarchy);
    if (this.dataHierarchy.data.length > 0 && this.dataHierarchy.data[0].items == null) {
      this.disableSelector = true;
      this.selectedName = "No branches available";
    } else if (this.selectedName == null && this.selectedId != null) {
      // if a location name is not passed in as an input, we set it using the id
      this.selectedName = this.dataHierarchy.flatData.find(l => l.id == this.selectedId).locationName;
    }
    this.addExpandListItem(this.dataHierarchy.data);
    this.setDropDownState();
  }

  private setDropDownState() {
    this.disableSelector = this.selectorDisabled;
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      // clicked outside => close dropdown list
      this.selectorOpened = false;
    }
  }

  public closeDropDown() {
    this.selectorOpened = false;

  }

  public onItemSelected(data: any) {
    this.selectorOpened = false;
    this.onChange.emit(data);
    this.selectedName = data.name;
  }

  private addExpandListItem(treeItem: any) {
    treeItem.forEach(item => {
      if (item.items && item.items.length > 0) {
        this.expandedKeys.push(item.id);
        this.addExpandListItem(item.items)
      }
    });
  }

  public itemClick() {
    if (!this.selectorDisabled) {
      this.selectorOpened = !this.selectorOpened;
    }
  }

}

